// Global Instructions Rule Applied!
//
// In-app help — the "?" guide drawer's article shape.
//
// Content is authored in cfg (cfg.help_articles / cfg.help_article_sections),
// so rewording a guide is a migration rather than a frontend release. The
// schema is permissive (.passthrough() + defaults), mirroring
// agent_access_model's cfg half: cfg evolves, and the drawer reads the keys it
// knows. A guide that fails to parse must never take a screen down with it.

import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const HelpArticleSectionSchema = z
  .object({
    heading: z.string().optional().default(''),
    // Sanitized at the render sink (DOMPurify inside a shadow root).
    body_html: z.string().optional().default(''),
    // Names an entry in ui_configs/helpSections.ts, rendered after the prose.
    // Unknown keys render nothing, so a cfg row can never blank the drawer.
    component_key: z.string().nullish(),
    sort_order: z.number().optional().default(100)
  })
  .passthrough()

export const HelpArticleSchema = z
  .object({
    article_key: z.string().optional().default(''),
    title: z.string().optional().default(''),
    subtitle: z.string().optional().default(''),
    sections: z.array(HelpArticleSectionSchema).optional().default([])
  })
  .passthrough()

export type HelpArticle = z.infer<typeof HelpArticleSchema>
export type HelpArticleSection = z.infer<typeof HelpArticleSectionSchema>

export const validateHelpArticle = (data: unknown): HelpArticle =>
  validateWithZodSchema(HelpArticleSchema, data, 'HelpArticle') as HelpArticle
